import { render, staticRenderFns } from "./Hearts.vue?vue&type=template&id=1fa83504&scoped=true&"
import script from "./Hearts.vue?vue&type=script&lang=js&"
export * from "./Hearts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa83504",
  null
  
)

export default component.exports